
import { useTranslation } from 'react-i18next';

import { ParticipantAttribute } from '__generated__/graphql';

import AddressInput, { AddressInputValue } from './Attributes/AddressInput';
import DateOfBirthInput, { DateOfBirthInputValue } from './Attributes/DateOfBirthInput';
import GenderInput, { GenderInputValue } from './Attributes/GenderInput';
import NationalityInput, { NationalityInputValue } from './Attributes/NationalityInput';
import ParticipantAttributeInputProps from './ParticipantAttributeInputProps';
import PhoneInput, { PhoneInputValue } from './Attributes/PhoneInput';

type ParticipantInputValue = AddressInputValue
& DateOfBirthInputValue
& NationalityInputValue
& PhoneInputValue
& GenderInputValue
& PhoneInputValue;

const ParticipantAttributeInput = (props: ParticipantAttributeInputProps<ParticipantInputValue>) => {
  const { t } = useTranslation('common');

  return (
    <>
      {props.attribute === ParticipantAttribute.address && <AddressInput {...props} />}
      {props.attribute === ParticipantAttribute.date_of_birth && <DateOfBirthInput {...props} />}
      {props.attribute === ParticipantAttribute.nationality && <NationalityInput {...props} />}
      {props.attribute === ParticipantAttribute.emergency_phone && (
        <PhoneInput {...props} description={t('participant_attributes.emergency_phone_description')} />
      )}
      {props.attribute === ParticipantAttribute.gender && <GenderInput {...props} />}
      {props.attribute === ParticipantAttribute.phone && <PhoneInput {...props} />}
    </>
  );
};

export default ParticipantAttributeInput;
